import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-10 mx-auto" }

import { ref, computed } from "vue";
import { formatter } from "@/db/ts/formatter";
import HttpStatusCode from "@/shared/ts/httpStatusCode";
import { app } from "@/guiide/ts/app";
import { useStore } from "vuex";
import Monitoring from "@/guiide/ts/monitoring/monitoring";


export default /*@__PURE__*/_defineComponent({
  __name: 'PensionManagement',
  setup(__props) {

const store = useStore();

async function onTransferPensionClicked() {
    Monitoring.gaEvent("TraPen", 0);
    await app.beginPensionTransfer([]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[6] || (_cache[6] = _createElementVNode("header", { class: "text-center mb-4" }, [
      _createElementVNode("h2", { class: "skin-page-heading" }, "[Product Name]")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, [
          _createElementVNode("strong", null, "Et Dolore Magna")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", null, [
          _createElementVNode("strong", null, "Expedita Distinctio")
        ], -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.", -1)),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn px-3 btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onTransferPensionClicked()))
          }, "Transfer My Pension")
        ])
      ])
    ])
  ], 64))
}
}

})